import { useAppSelector } from 'shared/hooks';
import { Admin, EAdminRoles } from 'shared/types';
import { useCallback } from 'react';

type SchoolParam = { schoolId: string } | {};

type Result = {
  getSchoolParams: () => SchoolParam;
};

const useSchoolParams = (): Result => {
  const currentUser = useAppSelector((state): Admin | null => state.auth.user);

  const resolveSchoolId = (school: Admin['school'] | undefined): string => {
    if (!school) return '';

    if (typeof school === 'string') {
      const parts = school.split('/').filter(Boolean);
      return parts[parts.length - 1] ?? '';
    }

    if ((school as any).id) {
      return String((school as any).id);
    }

    const path = (school as any).path;
    if (typeof path === 'string') {
      const parts = path.split('/').filter(Boolean);
      return parts[parts.length - 1] ?? '';
    }

    return '';
  };

  const getSchoolParams = useCallback(
    (): SchoolParam => {
      if (currentUser?.role !== EAdminRoles.SCHOOL_ADMIN) return {};

      const schoolId = resolveSchoolId(currentUser?.school);
      return schoolId ? { schoolId } : {};
    },
    [currentUser]
  );
  

  return {
    getSchoolParams
  };
};

export default useSchoolParams;
